import { render, staticRenderFns } from "./ApprovedandDeniedCourses.vue?vue&type=template&id=3196809c&"
import script from "./ApprovedandDeniedCourses.vue?vue&type=script&lang=js&"
export * from "./ApprovedandDeniedCourses.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedandDeniedCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports